import { ShopperAgentCapabilityKind } from "@redotech/redo-shopper-agent-common/capabilities/shopper-agent-capabilities";
import * as z from "zod";

export const validateShopperAgentCapabilityGuidance = {
  name: "validateShopperAgentCapabilityGuidance" as const,
  input: z.object({
    capability: z.enum(ShopperAgentCapabilityKind),
    /** Untrimmed, since the issues' offsets index into this text. */
    guidance: z.string().max(2000),
  }),
  output: z.object({
    issues: z.array(
      z.object({
        start: z.number().int(),
        end: z.number().int(),
        message: z.string(),
        kind: z.string().optional(),
      }),
    ),
  }),
};
